import Axios from 'axios';
import Vue from 'vue';
import i18n from '../../i18n';

import { API_HOST } from '../../config/app-const';

const state = {
  carmaAi: {
    isBusy: false,
    data: null,
    aiProviderIsBusy: false,
    aiProviders: null,
    aiProvidersError: null, 
    error: null,
  }
};

const getters = {
  carmaAi: (state) => {
    if (!state.carmaAi.data) return [];

    return state.carmaAi.data.data.data;
  }
}

const mutations = {
  LOAD_CARMA_AI_BUSY: (state, payload) => {
    state.carmaAi.isBusy = payload;
  },
  LOAD_CARMA_AI_SUCCESS: (state, payload) => {
    state.carmaAi.data = payload;
    state.carmaAi.error = null;
  },
  LOAD_CARMA_AI_FAIL: (state, payload) => {
    state.carmaAi.data = null;
    state.carmaAi.error = payload;
  },

  CREATE_OR_UPDATE_CARMA_AI_BUSY: (state, payload) => {
    state.carmaAi.isBusy = payload;
  },
  CREATE_OR_UPDATE_CARMA_AI_SUCCESS: (state, payload) => {
    state.carmaAi.data = payload;
    state.carmaAi.error = null;
  },
  CREATE_OR_UPDATE_CARMA_AI_FAIL: (state, payload) => {
    state.carmaAi.data = null;
    state.carmaAi.error = payload;
  },


  LOAD_AI_PROVIDER_BUSY: (state, payload) => {
    state.carmaAi.aiProviderIsBusy = payload;
  },
  LOAD_AI_PROVIDER_SUCCESS: (state, payload) => {
    state.carmaAi.aiProviders = payload;
    state.carmaAi.aiProvidersError = null;
  },
  LOAD_AI_PROVIDER_FAIL: (state, payload) => {
    state.carmaAi.aiProviders = null;
    state.carmaAi.aiProvidersError = payload;
  }
};

const actions = {
  getCarmaAi: ({ commit, rootState }, { projectId, pagination }) => {
    commit('LOAD_CARMA_AI_BUSY', true);

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    return Axios
      .get(`${API_HOST}/projects/${projectId}/open_ai_project`, config)
      .then(response => {
        commit('LOAD_CARMA_AI_SUCCESS', response.data)
        return response.data;
      })
      .catch(error => {
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')});

        console.error(error);
        commit('LOAD_CARMA_AI_FAIL', error)
      })
      .finally(() => commit('LOAD_CARMA_AI_BUSY', false));
  },

  postCarmaAi: ({ commit, rootState }, { projectId, data }) => {
    commit('CREATE_OR_UPDATE_CARMA_AI_BUSY', true);

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    return Axios
      .post(`${API_HOST}/projects/${projectId}/open_ai_project`, 
      data,
      config)
      .then(response => {
        commit('CREATE_OR_UPDATE_CARMA_AI_SUCCESS', response.data)
        Vue.notify({
          group: 'store_notifications',
          type: 'success',
          text: i18n.t('carma_ai.messages.success')
        });
        return response.data;
      })
      .catch(error => {
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')});

        console.error(error);
        commit('CREATE_OR_UPDATE_CARMA_AI_FAIL', error)
      })
      .finally(() => commit('CREATE_OR_UPDATE_CARMA_AI_BUSY', false));
  },


  getAiProviders: ({ commit, rootState }, { projectId, scope }) => {
    if (!scope) {
      console.error('[carmaAi/getAiProviders] scope is required');
      commit('LOAD_AI_PROVIDER_BUSY', false);
      return Promise.reject(new Error('scope is required'));
    }

    commit('LOAD_AI_PROVIDER_BUSY', true);

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    return Axios
      .get(`${API_HOST}/projects/${projectId}/open_ai_project/ai_providers?scope=${encodeURIComponent(scope)}`, config)
      .then(response => {
        commit('LOAD_AI_PROVIDER_SUCCESS', response.data)
        return response.data;
      })
      .catch(error => {
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')});

        console.error(error);
        commit('LOAD_AI_PROVIDER_FAIL', error)
      })
      .finally(() => commit('LOAD_AI_PROVIDER_BUSY', false));
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};